import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

// The establishment's full serving size list, for pickers that need every option at once rather
// than a page of them.
function useAllServingSizes(establishmentId, options = {}) {
  const queryReturnValues = useQuery(
    ["serving-sizes-all", { establishmentId }],
    inventoryClient.getAllServingSizes,
    {
      staleTime: 1000 * 60 * 10,
      ...options,
    }
  );

  return queryReturnValues;
}

export default useAllServingSizes;
